const socialTypes = [
    { value: 'discord',  text: 'Discord' },
    { value: 'facebook',  text: 'Facebook' },
    { value: 'instagram', text: 'Instagram' },
    { value: 'linkedin',  text: 'LinkedIn' },
    { value: 'personal_email', text: 'Personal Email'},
    { value: 'twitter',  text: 'Twitter' }
  ];

export default socialTypes;